import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { cleanObjectEmptyFields, createQueryKey } from '@hero/utils';

import { contactServices } from '../..';

function useGetAllContactIds(params = {}, options) {
  const {
    filters: { searchTerm = '', tags = [], ids = [] },
    options: {
      exists: [{ field = '', exist = '' }]
    }
  } = params;

  return useQuery(
    createQueryKey(QUERY_KEYS.useGetAllContactIdsKey, params),
    () =>
      contactServices.selectAll(
        cleanObjectEmptyFields({
          filters: {
            searchTerm,
            tags,
            ids
          },
          options: {
            exists: [
              {
                field,
                exist
              }
            ]
          }
        })
      ),
    options
  );
}

export { useGetAllContactIds };
